(() => {
  const bootstrap = window.__DebutifyBootstrap || {};
  const storageGet = (key) => {
    try {
      return JSON.parse(localStorage.getItem(key)) || [];
    } catch (error) {
      return [];
    }
  };

  window.Debutify = window.Debutify || {};

  Debutify.permanent_domain = bootstrap.permanent_domain || "";
  Debutify.designMode = Boolean(bootstrap.designMode);
  Debutify.host = bootstrap.host || window.location.host;
  Debutify.locale = bootstrap.locale || null;
  Debutify.language = Debutify.locale?.shop_locale || { locale: "en", enabled: true, primary: true, published: true };
  Debutify.available_languages = bootstrap.available_languages || [];
  Debutify.cart = bootstrap.cart || {};
  Debutify.settings = bootstrap.settings || {};
  Debutify.cart_drawer_id = bootstrap.cart_drawer_id || "";

  Debutify.widgets = Debutify.widgets || {
    header: {
      header_transparent: false,
      sticky_header_type: "none"
    },
    announcement: {
      sticky_bar: false
    },
    "cart-order-summary": {
      sticky_block: false
    },
    "infinite-scroll": {},
    "dbtfy-conditional-gift": {
      show_product_in_cart: true
    },
    cart_countdown_timer: [],
    "scrollbar-and-cursor": {},
    "cart-favicon": {},
    "back-to-top": {},
    "cart-notification": {},
    "cart-reminder": {}
  };

  Debutify.variables = Debutify.variables || { widgets: {} };
  Debutify.wishlist = storageGet("dbtfy-wishlist");
  Debutify.compare = storageGet("dbtfy-compare");
  Debutify.recentlyViewed = storageGet("dbtfy-recently-viewed");
  Debutify.checkout = Debutify.checkout || {};
  Debutify.reviewAPIPrefix = "https://theme-api.debutify.com/api/";
  Debutify.currency = bootstrap.currency || {};

  Debutify.replaceVariables = function replaceVariables(html, data, prefix = "{", suffix = "}") {
    const regex = new RegExp(`${prefix}(\\w+)${suffix}`, "g");
    return html.replace(regex, (match, key) => (key in data ? data[key] : match));
  };

  Debutify.fetchProductMarkup = async function fetchProductMarkup(url) {
    const localePrefix = Debutify.language?.primary ? "" : `/${Debutify.language?.locale || "en"}`;

    try {
      const res = await fetch(`${localePrefix}${url}`);
      if (!res.ok) {
        console.error(`HTTP-Error: ${res.status}`);
        return null;
      }

      return await res.text();
    } catch (error) {
      console.error(`Error: ${error}`);
      return null;
    }
  };

  Debutify.removeLocalFromUrl = function removeLocalFromUrl(url) {
    return url.replace(`/${Debutify.language?.locale || "en"}`, "");
  };

  Debutify.ajaxAddToCart = async function ajaxAddToCart(data) {
    const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    let error = false;
    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => formData.append(key, value));

    if (cart) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    config.body = formData;

    try {
      const response = await fetch(`${routes.cart_add_url}`, config);

      if (!response.ok) {
        const errorResponse = await response.json();
        publish(PUB_SUB_EVENTS.cartError, {
          source: "product-form",
          productVariantId: formData.get("id"),
          errors: errorResponse.errors || errorResponse.description,
          message: errorResponse.message
        });
        error = true;
        return;
      }

      const jsonResponse = await response.json();

      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (!error) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: formData.get("id"),
          cartData: jsonResponse
        });
      }

      error = false;
      cart.renderContents(jsonResponse);
    } catch (e) {
      console.error(e);
    } finally {
      if (cart && cart.classList.contains("is-empty")) {
        cart.classList.remove("is-empty");
      }
    }
  };

  Debutify.showCartDrawer = function showCartDrawer() {
    const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    if (!cart) return;

    cart.classList.remove("active");
    cart.classList.remove("hidden");
    setTimeout(() => {
      cart.classList.add("active");
      document.querySelector("cart-order-summary")?.stickyBlock();
    }, 300);
  };

  Debutify.hideCartDrawer = function hideCartDrawer() {
    const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    if (cart) cart.classList.add("hidden");
  };

  Debutify.removeHTMLTags = function removeHTMLTags(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    return (doc.body.textContent || "").trim();
  };

  Debutify.ready = true;
  window.dispatchEvent(new CustomEvent("debutify:ready", { detail: Debutify }));

  const originalDebutify = { ...Debutify };
  window.__OriginalDebutify = originalDebutify;

  function ensureDebutify() {
    if (!window.Debutify) {
      window.Debutify = { ...originalDebutify };
    }
  }

  let monitorCount = 0;
  const monitor = setInterval(() => {
    monitorCount += 1;
    ensureDebutify();

    if (monitorCount > 60) {
      clearInterval(monitor);
    }
  }, 500);

  document.addEventListener("DOMContentLoaded", ensureDebutify);
  window.addEventListener("load", ensureDebutify);

  Object.defineProperty(window, "Debutify", {
    get() {
      return this._debutify || originalDebutify;
    },
    set(value) {
      this._debutify = value === undefined || value === null ? originalDebutify : value;
    },
    configurable: false,
    enumerable: true
  });

  window._debutify = Debutify;
})();
